import { cn } from '@lib/utils';
import { FunctionComponent, ReactNode } from 'react';

type BlueLabelProps = {
  className?: string;
  text: ReactNode;
};

export const BlueLabel: FunctionComponent<BlueLabelProps> = (props) => {
  const { className, text } = props;

  return <div className={cn('text-[#3D2EFF] font-medium text-sm', className)}>{text}</div>;
};
